import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=647fc614&"
import script from "./WishList.vue?vue&type=script&lang=ts&"
export * from "./WishList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports